import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import {Router,ActivatedRoute} from "@angular/router";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { fuseAnimations } from '@fuse/animations';
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { Requerimientos3Service } from "app/main/pagina/tools/requerimientos3/requerimientos3.service";
import { DATOS_API } from 'app/auth/auth.datos';
@Component({
  selector: 'app-confi-correo',
  templateUrl: './confi-correo.component.html',
  styleUrls: ['./confi-correo.component.scss'],
  animations : fuseAnimations
})
export class ConfiCorreoComponent implements OnInit {
  parametroProductoId: string;
  parametroEmpresaId: string;
  actualizo=false;
  urlImagenLog= DATOS_API.urlAssets+'/platform/img/Fondo-Plataforma.jpg';
  constructor(private _fuseConfigService: FuseConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private reqService: Requerimientos3Service,) {

      lang_requerimientos.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });

    this.activatedRoute.params.subscribe(params => {
      console.log(params);

      this.parametroEmpresaId = params.idEmpresa;
        this.parametroProductoId = params.idProducto;
    });
    let idiomaNavegador = navigator.language.split("-");

    let idiomaCGO: string;
    switch(idiomaNavegador[0]){
      case 'en': idiomaCGO = 'en'; break;
      case 'es': idiomaCGO = 'es'; break;
      case 'tr': idiomaCGO = 'tr'; break;
      case 'zh':
        switch (idiomaNavegador[1]) {
          case 'TW': idiomaCGO = 'zh1'; break;
          case 'CN': idiomaCGO = 'zh2'; break;
          default: idiomaCGO = 'zh1';
        }
      break;
      default: idiomaCGO = 'en';
    }

    this.translateSrv.use(idiomaCGO);
   }

  ngOnInit() {
    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true },
        toolbar  : {hidden: true },
        footer   : {hidden: false },
        sidepanel: {hidden: true }
      }
    }
this.comfirmarBanderaTestEmails();
  }


comfirmarBanderaTestEmails(){
  let datos={
    empresaId:this.parametroEmpresaId,
    productoId:this.parametroProductoId,
  }
  // console.log("datos::::::",datos);


  this.reqService.actualizaBanderaTestEmailServ(this.parametroEmpresaId,this.parametroProductoId).subscribe((respuesta:any) => {
    console.log(respuesta);
    this.actualizo=true;
  setTimeout(() => {
    Swal.fire({
      icon: 'info',
      title: this.translateSrv.instant('REQUERIMIENTOSV3.SUCCES_CONF_EMA.MODAL_INSTRUCCI'),
      showConfirmButton: false,
      allowOutsideClick: false,
    })

  }, 1000);
  });
}


}
